import MfContainer from './mf_container'

export default MfContainer
